'use client';

import QueryMatchLanding from '@/components/QueryMatchLanding';

export default function SalonAnsweringServicePage() {
  return (
    <QueryMatchLanding
      pageName="Salon Answering Service"
      analyticsContext="salon_answering_service"
      eyebrow="Salon answering service"
      h1="Salon Answering Service That Books While You're With Clients"
      subhead="Stop losing appointments to voicemail during color services. Greet answers, books, and handles FAQs-without a $200–$400/mo answering service bill."
      bullets={[
        'Books appointments into your calendar during the call',
        'Answers hours, services, and pricing FAQs consistently',
        'Covers evenings and weekends when clients actually call to book',
        'Flat monthly rate-no per-minute answering service fees',
      ]}
      industryLabel="Salons & Spas"
      industryHref="/salon"
      industryCtaLabel="See the full salon page"
      accent="rose"
    />
  );
}
